module.exports = __webpack_public_path__ + "static/media/recutment_users.0d6fe5fb.gif";